<template>
    <div class="scroll-manager"></div>
</template>

<script>
    export default {
        name: 'ScrollManager',
        data: function() {
            return {
                sensitivity: 40,
                touchY: 0,
            }
        },
        mounted: function() {
            this.trackScroll();
            window.addEventListener('scroll', this.trackScroll);
            window.addEventListener('wheel', this.trackWheel);
            if ("ontouchstart" in window) {
                window.addEventListener('touchstart', this.trackTouchStart);
                window.addEventListener('touchend', this.trackTouchEnd);
            }
        },
        methods: {
            trackScroll: function(event) {
                this.$store.commit('scroll', {
                    y: window.scrollY
                });
            },
            trackWheel: function(event) {
                if (event.deltaY <= -this.sensitivity) {
                    this.$store.commit('wheel', {
                        direction: 'up'
                    })
                }else if (event.deltaY >= this.sensitivity) {
                    this.$store.commit('wheel', {
                        direction: 'down'
                    })
                }
            },
            trackTouchStart: function(event) {
                this.touchY = event.touches[0].clientY;
            },
            trackTouchEnd: function(event) {
                if (event.changedTouches[0].clientY - this.touchY <= -this.sensitivity) {
                    this.$store.commit('wheel', {
                        direction: 'down'
                    }) 
                }else if (event.changedTouches[0].clientY - this.touchY >= this.sensitivity) {
                    this.$store.commit('wheel', {
                        direction: 'up'
                    })                    
                }
            }
        }
    }
</script>